<template>
    <div style="height: 100%;width: 100%;">
        <div style="display: flex; width: 100%">
            <div style="width: 65%;margin: 10px;height: 30px;overflow-x: scroll;display: flex;">
                <el-input v-model="formDatas.iaTitle" style="width: 140px !important;" size="mini " placeholder="请输入标题"
                    clearable></el-input>
                    <el-select size="small" v-model="formDatas.iuId" clearable @change="partserch" placeholder="请选择用户"
                        v-if="iuPost == 2" style="width: 130px">
                        <el-option v-for="(item, index) in userarr" :label="item.iuName" :value="item.iuId"
                            :key="index"></el-option>

                    </el-select>
                <el-button type="info" size="small" icon="el-icon-search" @click="partserch"
                    style="margin-right: 10px;font-size: 10px;"></el-button>

            </div>

            <div style="width: 35%; height: 40px;margin: 10px 0;">
                <!-- <el-button type="success" size="small" style="margin-right: 20px" @click="BoxOpen">新增录音</el-button> -->

                <el-dropdown size="small" split-button type="warning" style="width: 100%;" trigger="click"
                    @click="BoxOpen()" @command="BoxOpen">
                    新增录音
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item style="background-color: #E6A23C;color: white;margin: 5px 0;"
                            command="1">批量新增录音</el-dropdown-item>
                            <!-- <el-dropdown-item style="background-color: #E6A23C;color: white;margin: 5px 0;"
                                command="2">批量导出录音</el-dropdown-item> -->
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <div style="width: 100%;height: calc(100% - 100px);overflow:auto;" v-infinite-scroll="load"
            infinite-scroll-disabled="disabled" infinite-scroll-immediate="false" infinite-scroll-distance="50" v-if="tableData.length > 0">
            <el-checkbox-group v-model="checkList">
            <el-card v-for="(item, index) in tableData" style="margin: 5px;">
                <div style="display: flex;align-items: center;">
                    <div style="width: 20%;text-align: center;color:#409EFf ;">
                        <el-checkbox :label="item.iaId" style="width: 100%;">{{ index + 1 }}</el-checkbox>
                    </div>
                    <div style="width: 70%;">
                        <div style="margin: 10px;">面试官 : <span style="color:#409EFf ;">{{ item.iuName }}</span></div>
                        <div style="margin: 10px;">标题 : <span style="color:#409EFf;">{{ item.iaTitle }}</span>
                            <span v-if="item.iaExistsEos == 1" style="color: red;">(文件损坏,请重新上传)</span> </div>
                        <div style="margin: 10px;">备注 : <span style="color:#409EFf;">{{ item.iaDes }}</span></div>
                    </div>
                    <div style="width: 20%;">
                        <el-button size="mini" type="text" style="margin: 5px;" @click="audioClick(item)"  v-if="item.iaPath != '***'"> 播放</el-button>
                        <p>
                            <el-button size="mini" type="text" style="margin: 5px;color: red;" @click="handleDelete(item)" v-if="item.iaPath != '***'">
                                删除</el-button>
                        </p>
                        <p v-if="postid == 2 && item.iaExistsEos == 2">
                            <el-button size="mini" type="text" style="margin: 5px;color: red;" @click="Download(item)">
                                下载</el-button>
                        </p>
                    </div>
                </div>


            </el-card>
        </el-checkbox-group>
            <p v-if="loading" style="width: 100%;text-align: center;margin: 15px;">加载中...</p>
            <p v-if="noMore" style="width: 100%;text-align: center;margin: 15px;">没有更多了</p>
        </div>
        <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑录音' : '新增录音'" :before-close="handleClose"
            :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer" size="100%">
            <div class="demo-drawer__content" style="height: 90%;">
                <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                    <div style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 20px 15px;overflow-x: hidden;">
                        <el-form-item label="录音标题(格式:日期-岗位-姓名-反馈)" prop="iaTitle">
                            <el-input v-model="form.iaTitle" style="width: 50%;" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="录音地址" prop="iaPath">
                            <my-upload ref="OtherImgupload" @fileChange="OtherImgChange" :filearr="OtherImgfileList"
                                :limit="OtherImglimit" style="margin: 10px 5px 5px;" type="text" accept=".mp3,.flac,.ogg,.cd,.cda,.ape,.asf,.rm,
                                .mov,.amr,.realaudio,.pcm,.avi,.3gp,.mkv,.vbr,.vqf,.aiff,.aif,.oggvorbis,.au,.m4a,.aac,.x-m4a,.mpeg,.mpeg-4,.adts,.wav,.wave,.wma,.midi,.mid">
                            </my-upload>
                            <el-input disabled v-model="form.iaPath" style="width: 50%;" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="备注" prop="iaPath">
                            <el-input v-model="form.iaDes" style="width: 50%;" placeholder="请输入"></el-input>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
            <div class="demo-drawer__footer" style="margin-top: 10px;">
                <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
                <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
                    确 定</el-button>
            </div>
        </el-drawer>
        <el-dialog title="批量新增(文件名称格式:日期-岗位-姓名-反馈)" :visible.sync="IsAdd" width="100%" top="8vh">
            <div style="height: 70vh;">
                <div>
                    <my-upload ref="OtherImgupload" @fileChange="OtherImgChange" :filearr="OtherImgfileList"
                        :limit="addLimit" style="margin: 10px auto;width: 100%;height: 100%;overflow-y: scroll;" type="text" accept=".mp3,.flac,.ogg,.cd,.cda,.ape,.asf,.rm,
                                .mov,.amr,.realaudio,.pcm,.avi,.3gp,.mkv,.vbr,.vqf,.aif,.oggvorbis,.au">
                    </my-upload>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="bulkAdditionsClose">取 消</el-button>
                <el-button type="primary" @click="bulkAdditions">确定</el-button>
            </div>
        </el-dialog>
        <div style="width: 100%;position:fixed;bottom: 5px;background-color: white;
             box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)" v-if="audioShow">
            <i class="el-icon-close" style="margin-left: 95%;" @click="playbackRate = 1.0,audioShow = false"></i>
            <div style="width: 95%;display: flex;margin: 0 auto;flex-direction: row-reverse;">
                    <el-button type="success" size="mini" @click="increaseSpeed">增加播放速度</el-button>
                     <div style="margin: 0 10px;">  {{ playbackRate.toFixed(1) }} </div>
                    <el-button type="danger" size="mini" @click="decreaseSpeed">减少播放速度</el-button>
                    <el-button style="margin-right: 10px;" type="primary" size="mini" @click="restoreSpeed">恢复播放速度</el-button>
            </div>
            <aplayer ref="aplayer" :music="audio[0]"  fixed v-if="audio.length > 0" :key=audio[0].src    @ended="onEnded" />
        </div>
    </div>
</template>
  
<script>
import saveAs from 'file-saver';
var FileSaver = require('file-saver');
import { getIvAudioList, addIvAudio, updateIvAudio, deleteIvAudio, getIvUserList } from "../api/api";
import aplayer from "vue-aplayer";
export default {
    name: "",
    components: {
        aplayer
    },
    data() {
        return {
            playbackRate: 1.0, // 初始播放速度为1
            postid:'',
            checkList:[],
            addLimit:9,
            audioSuccessNum: 0,
            audioFIle: [],
            IsAdd: false,
            loading: false,
            count: 1,
            userarr: [],
            audioShow: false,
            audio: [],
            OtherImglimit: 1,
            OtherImgfileList: [],
            key: 'iaId',
            dialog: false,
            edit: false,
            form: {
                iaId: '',
                iaTitle: '',
                iaPath: '',
                iaDes: '',
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columns: [
                {
                    field: "",
                    key: "checkbox",
                    // type=checkbox
                    type: "checkbox",

                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "iuName",
                    key: "iuName",
                    title: "面试官",
                    align: "center",
                    edit: false,
                },
                {
                    field: "iaTitle",
                    key: "iaTitle",
                    title: "标题",
                    align: "center",
                    edit: true,
                },
                {
                    field: "iaDes",
                    key: "iaDes",
                    title: "备注",
                    align: "center",
                    edit: true,
                },

                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 200,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.audioClick(row)}
                                >
                                    播放
                                </el-button>
                                <el-button
                                    size="mini"
                                    type="text"
                                    style="color: red"
                                    on-click={() => this.handleDelete(row)}
                                >
                                    删除
                                </el-button>
                            </span>
                        );
                    },
                },
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                iuId: '',
                iaTitle: '',
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.postid = localStorage.getItem('iuPost')
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        this.iuPost = localStorage.getItem("iuPost");
        getIvUserList({ iuPost: 1 }).then(res => {
            this.userarr = res.data
        })
        this.getList();
    },
    computed: {
        noMore() {
            return this.count >= this.totalCount
        },
        disabled() {
            return this.loading || this.noMore
        }
    },
    mounted() { },
    methods: {
        restoreSpeed() {
            this.playbackRate = 1.0;
            this.setPlaybackRate(this.playbackRate);
        },
        increaseSpeed() {
            this.playbackRate += 0.1; // 增加0.1倍
            this.setPlaybackRate(this.playbackRate);
        },
        decreaseSpeed() {
            this.playbackRate -= 0.1; // 减少0.1倍
            this.setPlaybackRate(this.playbackRate);
        },
        setPlaybackRate(rate) {
            if (this.$refs.aplayer) {
                const audio = this.$refs.aplayer.audio;
                if (audio) {
                    audio.playbackRate = rate;
                }
            }
        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        Download(row) {
            this.openLoading()
            const suffix = row.iaTitle + '.' + row.iaPath.substring(row.iaPath.lastIndexOf('.') + 1)
            //console.log(suffix);
            FileSaver.saveAs(row.iaPath, suffix)
            this.loadings.close()
        },
        bulkAdditionsClose() {
            this.IsAdd = false;
            this.form.iaPath = '';
            this.form.iaTitle = ''
            setTimeout(() => {

                this.$refs.OtherImgupload.fileAllRemove()
                this.OtherImgfileList = [];

            }, 10)
        },
        bulkAdditions() {
            this.$confirm("是否确定要批量新增吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.audioFIle.forEach((item, index) => {
                        const s = {
                            iaTitle: item.fileName.substring(0,item.fileName.lastIndexOf('.')),
                            iaPath: item.fileurl
                        };


                        addIvAudio(s).then(res => {
                            this.audioSuccessNum += 1;
                            //console.log(this.audioSuccessNum);
                            if (this.audioSuccessNum == this.audioFIle.length) {
                                //console.log('成功');
                                this.audioSuccessNum = 0
                                this.$message({
                                    type: "success",
                                    message: "上传成功!",
                                });
                                this.bulkAdditionsClose();
                                this.getList()
                            }
                        })


                    })

                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })

        },
        load() {
            //console.log('加载');
            this.count += 1
            this.formDatas.currentPage = this.count;
            this.loading = true
            getIvAudioList(this.formDatas).then((res) => {
                this.loading = false
                this.tableData.push(...res.data);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        onEmptied(){
            alert('错误')
        },
        onEnded() {
            
            //console.log('借宿');
            this.audio = [];
            this.audioShow = false;
        },
        audioClick(row) {

            this.audio = []
            const s = {
                title: row.iaTitle,
                artist: row.iuName,
                src: row.iaPath,
                pic: 'http://eos-shanghai-2.cmecloud.cn/aojv/interview/682c50e8278747d280437f3a438b990e.png', // prettier-ignore
                lrc: '',
            }
            this.audio.push(s);
            this.audioShow = true;
        },
        OtherImgChange(file) {
            //console.log(file);
            if(file.length >1){
                this.audioFIle = file
            }else{
                this.audioFIle = file
                this.$set(this.form, 'iaPath', file[0].fileurl);
                this.$set(this.form, 'iaTitle', file[0].fileName.substring(0,file[0].fileName.lastIndexOf('.')));

                this.$message({
                type: "success",
                message: "上传成功!",
            });
            }
           
           
        
        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {

                    deleteIvAudio({ iaId: row.iaId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {

                const obj = {
                    OtherImgfileList: 'iaPath',

                }
                for (let item in obj) {
                    for (let key in data) {
                        if (key == obj[item] && data[key]) {
                            //console.log(data[obj[item]]);
                            const img = {
                                name: data[obj[item]],
                                url: data[obj[item]],
                            }
                            this.$set(this[item], 0, img)
                        }
                    }
                }
            });
            this.$nextTick(() => {
                this.form = data;
            })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        addIvAudio(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateIvAudio(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen(e) {
            if (!e) {
                this.dialog = true;

            }  else if (e == 1) {
                this.IsAdd = true;
            } else {
                if (this.checkList.length == 0) {
                    this.$message({
                        showClose: true,
                        message: "请选择",
                        type: 'danger'
                    });
                } else {
                    //console.log(this.checkList);
                    this.openLoading()
                    this.tableData.forEach((data, id) => {
                        this.checkList.forEach((item, index) => {
                            if (data.iaId == item) {
                                const suffix = data.iaPath.substring(data.iaPath.lastIndexOf('.') + 1)
                                //console.log(suffix);
                                let url = window.URL.createObjectURL(new Blob([data.iaPath]))
                                // 生成一个a标签
                                let link = document.createElement('a')
                                link.style.display = 'none'
                                link.href = url
                                link.download = data.iaTitle + '.' + suffix
                                document.body.appendChild(link)
                                link.click()
                                link.remove()

                            }
                            if (id == this.tableData.length - 1) {
                                this.loadings.close()
                            }
                        })
                    })

                }
            }

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;

            this.$refs['formRef'].resetFields();
            setTimeout(() => {

                this.$refs.OtherImgupload.fileAllRemove()
                this.OtherImgfileList = [];

            }, 10)
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.iaId = row.iaId
                    //console.log(jsonObj);
                    updateIvAudio(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                //console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // //console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        //console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(index, 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                //console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            //console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getIvAudioList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getIvAudioList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = Math.ceil(res.total / 10);
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
            getIvAudioList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = Math.ceil(res.total / 10);
            });
        },
    },
};
</script>
  
<style>
.el-checkbox-group {
    font-size: 14px;
}
.el-scrollbar .el-scrollbar__bar {
    opacity: 1 !important;
}

.el-dialog__body {
    padding: 5px 0;
}

.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}

.el-card__body {
    padding: 5px 10px;
}

.el-message-box {
    width: 80%;
}
</style>
  